<template>
  <v-flex d-flex>
    <v-container fluid>
      <v-fab-transition>
        <v-btn v-show="toolbarReady" fixed bottom right dark fab color="pink" @click="refresh" :loading="loading">
          <v-icon>cached</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-card class="px-2 pb-2 mb-3">
        <v-card-title primary-title>
          <v-icon
            v-html="'mdi-checkbox-blank-circle'"
            :color="getStatusColor(ratesStatus)"
            class="mr-3"
          />
          <span class="title mr-2">Rates</span>
          <v-fade-transition>
            <sub v-if="rates.data.created_at" class="caption mr-2 my-2 grey--text">
              <i>(Latest: {{ getDateString(rates.data.created_at) }})</i>
            </sub>
          </v-fade-transition>
        </v-card-title>
        <v-slide-y-transition mode="out-in">
          <v-card-text v-if="rates.ready && rates.data.error" class="pt-0">
            <div class="d-inline-block">
              <v-alert color="error" outline :value="true" class="px-3 py-2 my-2">
                {{ rates.data.error }}
              </v-alert>
            </div>
          </v-card-text>
        </v-slide-y-transition>
        <v-fade-transition>
          <v-progress-linear v-if="rates.loading" indeterminate height="2" class="ma-0" style="position: absolute; bottom: -1px; left: 0; right: 0;"></v-progress-linear>
        </v-fade-transition>
      </v-card>
      <template v-for="item in tables.items">
        <MonitorTable
          ref="monitorTables"
          v-bind="item"
          class="mb-3"
        />
      </template>
    </v-container>
  </v-flex>
</template>

<script>
import MonitorTable from './MonitorTable'
import MongoService from '../../services/mongo.service'
import { getDateString } from '../../libs/utils'

export default {
  data () {
    return {
      tables: {
        ready: false,
        loading: false,
        items: [{
          title: 'Buffers',
          infoHeaders: [ 'client_id', 'account_id' ],
          types: [ 'historical-balances' ],
          query: async (types) => {
            return await MongoService.monitoring.buffers()
          }
        }, {
          title: 'Spreadsheets',
          infoHeaders: [ 'client_id' ],
          types: [ 'spreadsheet-reporting', 'spreadsheet-monitoring' ],
          query: async (types) => {
            return await MongoService.monitoring.spreadsheets()
          }
        }, {
          title: 'Bots',
          infoHeaders: [ 'client_id', 'account_id' ],
          types: [ 'historical-balances', 'historical-exchange-volumes', 'historical-bot-trades' ],
          query: async (types) => {
            return await MongoService.monitoring.bots()
          }
        }]
      },
      rates: {
        ready: false,
        loading: false,
        data: {}
      }
    }
  },
  computed: {
    toolbarReady () {
      return this.rates.ready && this.tables.ready
    },
    loading () {
      return this.tables.loading || this.rates.loading
    },
    ratesStatus () {
      if (!this.rates.ready) return null
      return this.rates.data.success
    }
  },
  async mounted () {
    await this.refresh()
  },
  methods: {
    getDateString,
    getStatusColor (value) {
      if (value === null) return null
      if (value === undefined) return 'success'
      return value ? 'success' : 'error'
    },
    async refresh () {
      /**
       * Rates
      */
      this.rates.loading = true
      this.fetchRates().then(() => {
        this.rates.loading = false
        this.rates.ready = true
      })
      /**
       * Tables
      */
      this.tables.loading = true
      let monitorTables = this.$refs.monitorTables
      monitorTables = Array.isArray(monitorTables) ? monitorTables : [monitorTables]
      Promise.all(
        monitorTables.map(component => component.refresh())
      ).then(() => {
        this.tables.loading = false
        this.tables.ready = true
      })
    },
    async fetchRates () {
      let item = (await MongoService.monitoring.rate())[0]
      if (!item) return
      item = this.finalizeItem(item)
      this.rates.data = item
    },
    finalizeItem (obj) {
      obj.success = obj.status !== 'error'
      obj.errors = obj.error ? [obj.error] : []
      return obj
    }
  },
  components: {
    MonitorTable
  }
}
</script>
